module.exports = __webpack_public_path__ + "static/media/caution.a122088b.png";